export const config = {
  serverURL: "https://api-stg01.apps.mktnxt.com/api/v1.0",
  NXTServerURL: "https://{tenant}.mediascape-stg01.apps.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "stg01",
  clientId: "gc1n1uiohdipc2hvdutnbho6d",
  cognitoDomain: "duplo-nonprod.auth.us-east-1.amazoncognito.com",
  identityProvider: "duplo-nonprod",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-stg01.apps.mktnxt.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_aCLCffalK",
};
